"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  label: 'Good',
  color: '#6ABD45',
  id: '1'
}, {
  label: 'Okay',
  color: '#F2D600',
  id: '2'
}, {
  label: 'Bad',
  color: '#FF9F19',
  id: '3'
}, {
  label: '',
  color: '#74CEDD',
  id: '4'
}, {
  label: '',
  color: '#0279BE',
  id: '5'
}];
exports.default = _default;